module.exports = __webpack_public_path__ + "static/media/lotrpic.90237f1a.png";